// extracted by mini-css-extract-plugin
export default {"Banner":"DisconnectedBanner_Banner__xFkSy","PrimaryFont":"DisconnectedBanner_PrimaryFont__5M4Ek","SecondaryFont":"DisconnectedBanner_SecondaryFont__eITGU"};